module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gb-Ha-Ib-Ja.b8aa459f.png";